import React from 'react';

import { NoRisks } from './components/NoRisks';
import { Risks } from './components/Risks';

import style from './style/index.scss';

/**
 * @param {Object} props - props object
 * @param {boolean} props.hasHighRiskScore - true if any score is high or very high
 * @param {Object} props.section - section object
 * @param {Object} props.i18nParticipation - i18n object
 * @param {Function} props.showAllScoresModal - open modal to show all scores in detail
 * @param {Function} props.openSingleScaleScoreModal - open modal to show a single scale score in detail
 *
 * @returns {JSX.Element} - main derailment section overview
 */
export function MainDerailmentSectionOverview(props) {
    const {
        i18nParticipation,
        hasHighRiskScore,
        scoreWithRisks,
        openSingleScaleScoreModal,
        showAllScoresModal
    } = props;

    const showAllScoresButton = (
        <button className={style.showAllScores} onClick={showAllScoresModal}>
            {i18nParticipation.report_derailment_show_scores_link}
        </button>
    );

    return (
        <div>
            {hasHighRiskScore ? (
                <React.Fragment>
                    <p className={style.risksTitle}>
                        {i18nParticipation.report_derailment_high_scores_title}
                    </p>
                    <Risks scores={scoreWithRisks} openSingleScaleScoreModal={openSingleScaleScoreModal} />
                    <div className={style.showAllScoresRow}>
                        {showAllScoresButton}
                    </div>
                </React.Fragment>

            ) : (<NoRisks showAllScoresButton={showAllScoresButton} i18nParticipation={i18nParticipation} />)}
        </div>
    );
}
